var _path;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOverviewTop(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 602,
    height: 342,
    viewBox: "0 0 602 342",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M-48.444 340.82c85.041-1.679 172.379-24.053 237.35-89.369 41.549-41.595 69.893-94.636 81.449-152.419 11.546 57.786 39.892 110.831 81.449 152.419 61.984 62.315 145.25 87.333 225.822 89.453 3.801 0 7.602.147 11.382.147h12.99v-37.633c0-4.953-.105-9.906-.355-14.859-3.488-72.726-32.475-146.017-86.963-200.776C456.956 29.77 346.186.513 270.543.05h-.292C194.461.512 83.858 29.749 26.092 87.804c-55.74 55.997-84.77 131.43-87.15 205.687v47.329h12.614zm547.775-232.322c-.209 0 0 0 0 0z",
    fill: "#F8F5FF"
  })));
}
export default SvgOverviewTop;